import {
    GET_LOCATION_LIST
    , UPDATE_LOCATION
} from '../actions/storedLocationActions';

const initialState = {
    storedLocationList: []
    ,storedLocationListIsFetching: false
    ,locationIsUpdating: false
};

export function storedLocation(state = initialState, action) {
    switch (action.type) {

        case GET_LOCATION_LIST.pending:
        {
            return {
                ...state,
                storedLocationListIsFetching: true,
            };
        }
        case GET_LOCATION_LIST.fulfilled:
        {
            return {
                ...state,
                lastError: {},
                storedLocationListIsFetching: false,
                storedLocationList: action.payload
            };
        }

        case GET_LOCATION_LIST.rejected:
        {
            return {
                ...state,
                lastError: action.payload,
                storedLocationListIsFetching: false,
                storedLocationList: initialState.storedLocationList
            };
        }

        case UPDATE_LOCATION.pending:
        {
            return {
                ...state,
                locationIsUpdating: true,
            };
        }
        case UPDATE_LOCATION.fulfilled:
        {
            return {
                ...state,
                lastError: {},
                locationIsUpdating: false,
                storedLocationList: action.payload
            };
        }

        case UPDATE_LOCATION.rejected:
        {
            return {
                ...state,
                lastError: action.payload,
                locationIsUpdating: false,
                storedLocationList: initialState.storedLocationList
            };
        }
        default: {
            return state;
        }
    }
} 
